module.exports = __webpack_public_path__ + "img/_5.b0f3a6ad.png";